module.exports = require('./dist').default;
module.exports.default = module.exports;




//////////////////
// WEBPACK FOOTER
// ./node_modules/inferno-router/node_modules/inferno-component/index.js
// module id = 618
// module chunks = 0